<template>
<div id="arrivage-user-connection" class="data-list-container">
    <vs-table ref="table" v-model="selectedClient" pagination :max-items="itemsPerPage" search :data="dataList">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ dataList.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : dataList.length }} of {{ queriedItems }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=7">
                        <span>7</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=25">
                        <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=35">
                        <span>35</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color">Numéro Article</vs-th>
            <vs-th sort-key="Item_No" class="table_head_color">Description</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Date</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p>{{ tr.codeArticle  }}</p>
                    </vs-td>
                    <vs-td>
                        <p>{{ tr.description  }}</p>
                    </vs-td>
                    <vs-td>
                        <p>{{ filterDate(tr.dateArrivage) }}</p>
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>

</div>
</template>

<script>
import arrivageService from "@/http/requests/arrivage/index.js";
import jwtService from "@/http/requests/auth/jwt/index.js";
import moment from 'moment';
//import service from "./dashboardService.js";
export default {
    components: {

    },
    data() {
        return {
            itemsPerPage: 10,
            currentPage: 1,
            baseUrl: "",
            active: false,
            dialog: false,
            popupActiAdd: false,
            showChart: false,
            colorx: this.$store.state.themePrimaryColor,
            popupActivo5: false,
            showdata: false,
            selectedClient: null,
            dataList: [],
            queriedItems: 0,
            shadowpdf: false,
            cellAutoWidth: true,
            headerTitle: [
                "numeroArticle",
                "description",
                "dateArrivage",

            ],
            headerVal: ["numeroArticle", "description", "dateArrivage"],
            imgRemove: require("@/assets/images/portrait/small/remove.png"),
            imgUpdate: require("@/assets/images/portrait/small/update2.png"),
            imgpwd: require("@/assets/images/file-icons/password.png"),
            imgActiv: require("@/assets/images/file-icons/padlock.png")
        };
    },
    watch: {
        dataList: function () {
            this.$vs.loading.close("#arrivage-user-connection > .con-vs-loading");
        }
    },
    methods: {
        filterDate(value) {
             if (value) {
                 return moment(String(value)).format('MM/DD/YYYY hh:mm')
             }
        },
        loadData() {
            try {
                arrivageService.getAllArrivage().then(response => {
                    this.dataList = response.data
                })
                this.$vs.loading.close("#arrivage-user-connection > .con-vs-loading");
            } catch {
                this.$vs.loading.close("#arrivage-user-connection > .con-vs-loading");
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        this.isMounted = true;
        if (this.$store.state.article.clients.value == null) {
            this.$vs.loading({
                background: this.backgroundLoading,
                type: 'radius',
                container: "#arrivage-user-connection",
                scale: 0.45,
                clickEffect: true
            });
        }
    }
};
</script>

<style lang="scss">
#arrivage-user-connection {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
